import DocumentService from 'aurora-composition/services/documentService';
import history from 'aurora-utils/history';
import WorkflowService from 'aurora-composition/services/workflowService';
import isEmpty from 'lodash/isEmpty';
import OwnerService from 'aurora-composition/services/ownerService';
import PropertiesService from 'aurora-composition/services/propertyService';
import BuyersListService from 'aurora-composition/services/buyersListService';
import {
  CleverTapCancelApplicationDetails,
  CleverTapCancelApplicationDetailsSuccess,
  CleverTapCancelApplicationDetailsFailure,
  CleverTapGenericServiceSubmitEvent,
  CleverTapGenericServiceSubmitSuccessEvent,
  CleverTapGenericServiceSubmitFailureEvent,
  CleverTapServicesPreValidation,
  CleverTapServicesStartApplication,
} from 'aurora-utils/cleverTap.eventhelper';
import formatPreValidationForClevertap from 'aurora-utils/clevertap.validation.formatter';
import OffPlanService from '../../services/offPlanService';
import * as types from './constants';

export const initiateApplication = (params, successCB, errorCB) => async dispatch => {
  try {
    dispatch({ type: types.INITIATE_OFFPLAN_APPLICATION });
    const reqvalidate = {
      applicationType: params.applicationType,
      plotId: params.elmsPropertyId,
    };
    const validation = await WorkflowService.checkValidation(reqvalidate);
    if (!isEmpty(validation?.result)) {
      CleverTapServicesPreValidation({
        property_id: params.elmsPropertyId,
        application_type: params.applicationType,
        ...formatPreValidationForClevertap(validation?.result),
      });
      history.replace('/app/services/validations', {
        ...validation?.result,
      });
    } else {
      CleverTapServicesPreValidation({
        property_id: params.elmsPropertyId,
        application_type: params.applicationType,
      });
      CleverTapServicesStartApplication({
        property_id: params.elmsPropertyId,
        application_type: params.applicationType,
      });
      const OffplanInitiate = await OffPlanService.registerApplication(params);
      if (OffplanInitiate?.success) {
        dispatch({ type: types.INITIATE_OFFPLAN_APPLICATION_SUCCESS });
        history.push('/app/services/off-plan-registration/' + OffplanInitiate?.result?.id);
      }
      successCB && successCB(OffplanInitiate);
    }
  } catch (err) {
    errorCB && errorCB(err);
    dispatch({ type: types.INITIATE_OFFPLAN_APPLICATION_ERROR, payload: err });
  }
};

export const uploadDocument = (body, params) => async (dispatch, getState) => {
  try {
    dispatch({ type: types.UPLOAD_MUSATAHA_DOCUMENT });

    const { documents } = getState().offPlanReducer;

    const document = await DocumentService.uploadDocument(body, params);

    dispatch({
      type: types.UPLOAD_MUSATAHA_DOCUMENT_SUCCESS,
      payload: { documents: [...documents, document.result] },
    });
  } catch (error) {
    dispatch({ type: types.UPLOAD_MUSATAHA_DOCUMENT_ERROR, payload: error });
  }
};

export const downloadDocument = payload => async dispatch => {
  try {
    dispatch({ type: types.DOWNLOAD_DOCUMENT_MUSATAHA });

    const documentPdf = await DocumentService.downloadDocument(payload);
    const file = new Blob([documentPdf], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', `${payload?.fileName || 'MUSATAHA.pdf'}`);
    link.target = '_blank';

    document.body.appendChild(link);

    link.click();

    link.parentNode.removeChild(link);

    dispatch({ type: types.DOWNLOAD_DOCUMENT_MUSATAHA_SUCCESS });
  } catch (error) {
    dispatch({ type: types.DOWNLOAD_DOCUMENT_MUSATAHA_ERROR, payload: error });
  }
};

export const deleteDocument = (params, file) => async (dispatch, getState) => {
  try {
    dispatch({ type: types.UPLOAD_MUSATAHA_DOCUMENT });

    const { documents } = getState().offPlanReducer;

    await DocumentService.deleteDocument(params);

    dispatch({
      type: types.UPLOAD_MUSATAHA_DOCUMENT_SUCCESS,
      payload: { documents: documents.filter(doc => doc.id !== file.id) },
    });
  } catch (error) {
    dispatch({ type: types.UPLOAD_MUSATAHA_DOCUMENT_ERROR, payload: error });
  }
};

export const fetchWorkFlowApplication = id => async dispatch => {
  try {
    dispatch({ type: types.FETCH_APPLICATION_OFFPLAN });
    const resp = await OffPlanService.fetchOffPlanApplication(id);
    const newDocuments = await DocumentService.fetchApplicationDocuments({
      applicationId: id,
    });
    const propertyResult = await PropertiesService.fetchProperty(resp?.result?.applicationDetails?.plotID);
    let breakdown = null;
    try {
      const respPayment = await OffPlanService.fetchOffPlanPaymentBreakDown(id);
      breakdown = respPayment?.result;
    } catch (error) {
      breakdown = null;
    }
    dispatch({
      type: types.FETCH_APPLICATION_OFFPLAN_SUCCESS,
      payload: {
        application: resp.result,
        applicationId: id,
        buyers: resp.result?.buyers,
        brokers: resp.result?.brokers,
        instalmentPlanList: resp.result?.instalmentPlanList,
        paymentPlanType: resp.result?.paymentPlanType,
        contractDetails: resp.result?.contractDetails,
        representativeDetails: resp.result?.representativeDetails,
        documents: newDocuments?.result,
        property: propertyResult?.result,
        breakdown,
        sellers: resp?.result?.tenants,
      },
    });
  } catch (error) {
    dispatch({ type: types.FETCH_APPLICATION_OFFPLAN_ERROR, payload: error });
  }
};

export const discardApplication = id => async (dispatch, getState) => {
  const { application } = getState().offPlanReducer;
  const cleverTapPayload = {
    applicationStatus: application?.applicationDetails?.applicationStatus,
    applicationId: application?.applicationDetails?.applicationId,
    applicationNumber: application?.applicationDetails?.applicationNumber,
    applicationType: application?.applicationDetails?.applicationType,
    contractNumber: application?.mortgage?.details?.contractNumber,
    contractStartDate: application?.mortgage?.details?.startDate,
    contractEndDate: application?.mortgage?.details?.endDate,
  };
  try {
    dispatch({ type: types.MUSATAHA_CANCEL_APPLICATION });
    CleverTapCancelApplicationDetails(cleverTapPayload);

    await WorkflowService.cancelApplication(id);
    dispatch({ type: types.MUSATAHA_CANCEL_APPLICATION_SUCCESS });
    CleverTapCancelApplicationDetailsSuccess(cleverTapPayload);

    history.replace('/app/services?slug=sale');
  } catch (error) {
    cleverTapPayload.errorCode = error?.statusCode;
    cleverTapPayload.errorMessage = error?.data?.result?.description;
    dispatch({ type: types.MUSATAHA_CANCEL_APPLICATION_ERROR, payload: error });
    CleverTapCancelApplicationDetailsFailure(cleverTapPayload);
  }
};

export const addToError = message => async dispatch => {
  dispatch({ type: types.ADD_TO_ERROR_INITITATE });

  setTimeout(() => {
    dispatch({
      type: types.ADD_TO_ERROR,
      payload: { statusCode: 600, message },
    });
  }, 200);
};
export const saveApplication = payload => async dispatch => {
  try {
    dispatch({ type: types.SAVE_APPLICATION_OFFPLAN });
    await OffPlanService.saveApplication(payload);
    const resp = await OffPlanService.fetchOffPlanApplication(payload.applicationId);
    // const respPayment = await OffPlanService.getPaymentBreakdownWaiver(payload.applicationId);
    dispatch({
      type: types.SAVE_APPLICATION_OFFPLAN_SUCCESS,
      payload: { application: resp?.result },
    });
    return resp;
  } catch (error) {
    dispatch({ type: types.SAVE_APPLICATION_OFFPLAN_ERROR, payload: error });
    return error;
  }
};
export const checkoutMusatahaWaive = (application, property, applicationId) => async dispatch => {
  const stepName = 'success';
  const CleverTapPayloadForSumbit = {
    stepName,
    screenName: `screen_${application?.applicationType}_${stepName}_view`,
    applicationStatus: application?.applicationDetails?.applicationStatus,
    applicationId: application?.applicationId,
    applicationNumber: application?.applicationDetails?.applicationNumber,
    applicationType: application?.applicationType,
  };
  try {
    dispatch({ type: types.CHECKOUT_MUSATAHA_APPLICATION });
    CleverTapGenericServiceSubmitEvent(CleverTapPayloadForSumbit);

    const musataha = await OffPlanService.checkoutMusatahaApplicationWaive(applicationId);
    dispatch({
      type: types.CHECKOUT_MUSATAHA_APPLICATION_SUCCESS,
      payload: musataha?.result,
    });
    CleverTapGenericServiceSubmitSuccessEvent(CleverTapPayloadForSumbit);
    history.replace('/app/services/off-plan/application/success', {
      application,
      property,
    });
  } catch (err) {
    CleverTapPayloadForSumbit.errorCode = err?.statusCode;
    CleverTapPayloadForSumbit.errorMessage = err?.data?.result?.description;
    dispatch({ type: types.CHECKOUT_MUSATAHA_APPLICATION_ERROR, payload: err });
    CleverTapGenericServiceSubmitFailureEvent(CleverTapPayloadForSumbit);
  }
};

export const fetchBrokerDetails = id => async dispatch => {
  try {
    dispatch({ type: types.FETCH_BROKER });
    // const { brokers } = getState().offPlanReducer;

    let broker = {};
    // let requiredCompanyDocs = null;

    broker = await OwnerService.fetchUserById(id + '?partyType=Broker');

    dispatch({ type: types.FETCH_BROKER_SUCCESS });
    return { broker, requiredCompanyDocs: [] };
  } catch (error) {
    dispatch({ type: types.FETCH_BROKER_ERROR, payload: error });
    return error;
  }
};
export const addBroker = apiResponse => async (dispatch, getState) => {
  try {
    dispatch({ type: types.ADD_BROKER });
    const { applicationId } = getState().offPlanReducer;
    // Add buyer (person)
    const requestPayload = {
      applicationId: applicationId?.toString(),
      userId: apiResponse.userId,
    };

    await OwnerService.addBroker(requestPayload);

    dispatch({ type: types.ADD_BROKER_SUCCESS });
    dispatch(fetchWorkFlowApplication(applicationId));
  } catch (error) {
    dispatch({ type: types.ADD_BROKER_ERROR, payload: error });
  }
};

export const deleteBroker = userId => async (dispatch, getState) => {
  try {
    dispatch({ type: types.DELETE_BROKER });

    const { applicationId } = getState().offPlanReducer;

    const requestPayload = {
      applicationId: applicationId.toString(),
      userId,
    };

    await OwnerService.deleteBroker(requestPayload);

    dispatch({ type: types.DELETE_BROKER_SUCCESS, payload: [] });
  } catch (error) {
    dispatch({ type: types.DELETE_BROKER_ERROR, payload: error });
  }
};

export const setContractDetails = payload => dispatch => {
  dispatch({ type: types.SET_CONTRACT_DETAILS, payload });
};
export const setBuyersDetail = payload => dispatch => {
  dispatch({ type: types.SET_BUYER_DETAIL, payload });
};

export const fetchBuyerDetails = (id, type) => async (dispatch, getState) => {
  try {
    dispatch({ type: types.FETCH_OFFPLAN_BUYER });
    const { buyers } = getState().offPlanReducer;

    let buyer = {};
    // let requiredCompanyDocs = null;

    if (type === 'person') {
      if (buyers.findIndex(item => item?.emiratesID === id) > -1) throw new Error('this_buyer_is_already_added');
      buyer = await OwnerService.fetchUserById(id);
    }

    if (type === 'company') {
      if (buyers.findIndex(item => item?.tradeLicenseNumber === id) > -1)
        throw new Error('this_buyer_is_already_added');
      buyer = await OwnerService.fetchCompanyByLicense(id);
    }

    dispatch({ type: types.FETCH_OFFPLAN_BUYER_SUCCESS });
    return { buyer, requiredCompanyDocs: [] };
  } catch (error) {
    dispatch({ type: types.FETCH_OFFPLAN_BUYER_ERROR, payload: error });
    return error;
  }
};
export const addBuyer = (apiResponse, state) => async (dispatch, getState) => {
  try {
    dispatch({ type: types.ADD_OFFPLAN_BUYER });
    const { applicationId, buyers } = getState().offPlanReducer;

    if (apiResponse?.userType === 'DARI_USER') {
      // Add buyer (person)
      const requestPayload = {
        applicationId: applicationId.toString(),
        userId: apiResponse?.userId,
        phoneNumber: apiResponse?.mobileNumber,
        email: apiResponse?.email,
      };
      await BuyersListService.addBuyer(requestPayload);

      const newBuyers = [...buyers];
      const buyerData = {
        ...apiResponse,
        ...state,
        userId: apiResponse?.userId,
      };
      const buyerIndex = buyers.findIndex(item => item.userId === apiResponse?.userId);
      if (buyerIndex > -1) {
        newBuyers[buyerIndex] = buyerData;
      } else {
        newBuyers.push(buyerData);
      }
      dispatch({
        type: types.ADD_OFFPLAN_BUYER_SUCCESS,
        payload: { buyers: newBuyers, buyerNonResidentAdded: true },
      });
    }

    if (state.userType === 'person') {
      // Add buyer (person)
      const requestPayload = {
        applicationId: applicationId.toString(),
        userId: apiResponse.userId,
        phoneNumber: apiResponse.phoneNumber,
        email: apiResponse.email,
      };
      await OwnerService.addBuyerPersonMusataha(requestPayload);

      const newBuyers = [...buyers];
      const buyerData = {
        ...apiResponse,
        ...state,
        userId: apiResponse?.userId,
      };
      const buyerIndex = buyers.findIndex(item => item.userId === apiResponse?.userId);
      if (buyerIndex > -1) {
        newBuyers[buyerIndex] = buyerData;
      } else {
        newBuyers.push(buyerData);
      }
      dispatch({
        type: types.ADD_OFFPLAN_BUYER_SUCCESS,
        payload: { buyers: newBuyers },
      });
    }

    if (state.userType === 'company') {
      // Add buyer (company)
      const requestPayload = {
        applicationId: applicationId.toString(),
        phoneNumber: apiResponse.mobileNumber,
        email: apiResponse.companyEmail,
        companyId: apiResponse.companyId,
      };

      await OwnerService.addBuyerPersonMusataha(requestPayload);

      const newBuyers = [...buyers];
      const buyerData = {
        ...apiResponse,
        ...state,
        companyId: apiResponse?.companyId,
      };
      const buyerIndex = buyers.findIndex(item => item.companyId === apiResponse?.companyId);

      if (buyerIndex > -1) {
        newBuyers[buyerIndex] = buyerData;
      } else {
        newBuyers.push(buyerData);
      }

      dispatch({
        type: types.ADD_OFFPLAN_BUYER_SUCCESS,
        payload: { buyers: newBuyers },
      });
    }
  } catch (error) {
    dispatch({ type: types.ADD_OFFPLAN_BUYER_ERROR, payload: error });
  }
};

function deleteChain(params) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await DocumentService.deleteDocument(params);
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
}
export const deleteBuyer = (ownerId, buyertype = 'person') => async (dispatch, getState) => {
  try {
    dispatch({ type: types.DELETE_OFFPLAN_BUYER });

    const { applicationId, applicationType, documents, buyers } = getState().offPlanReducer;

    // Delete files from the DB
    const removeFilesArray = documents
      .filter(doc => doc.userId === ownerId || (doc.poaOwnerId === ownerId && doc.type === 'POA_DOC'))
      .map(item => {
        const params = {
          applicationId,
          applicationType,
          documentType: item.type,
          subType: item.subType,
        };
        return deleteChain(params);
      });
    await Promise.all(removeFilesArray);

    const newDocuments = await DocumentService.fetchApplicationDocuments({
      applicationId,
    });
    const reqDelBuyer = {};
    if (buyertype === 'person') {
      reqDelBuyer.applicationId = applicationId;
      reqDelBuyer.userId = ownerId;
      reqDelBuyer.companyId = null;
    }

    if (buyertype === 'company') {
      reqDelBuyer.applicationId = applicationId;
      reqDelBuyer.userId = ownerId;
      reqDelBuyer.companyId = ownerId;
    }
    await OwnerService.deleteBuyerPersonMusataha(reqDelBuyer);

    const newBuyers = buyers.filter(buyer => {
      const id = buyer.userId || buyer.companyId;
      return id !== ownerId;
    });

    dispatch({
      type: types.DELETE_OFFPLAN_BUYER_SUCCESS,
      payload: { buyers: newBuyers, newDocuments },
    });
    dispatch(fetchWorkFlowApplication(applicationId));
  } catch (error) {
    dispatch({ type: types.DELETE_OFFPLAN_BUYER_ERROR, payload: error });
  }
};
export const fetchPoADetails = id => async dispatch => {
  try {
    dispatch({ type: types.FETCH_OFFPLAN_POA });

    const poa = await OwnerService.fetchUserById(id);

    dispatch({ type: types.FETCH_OFFPLAN_POA_SUCCESS });
    return poa;
  } catch (error) {
    dispatch({ type: types.FETCH_OFFPLAN_POA_ERROR, payload: error });
    return error;
  }
};
export const addPoA = payload => async dispatch => {
  try {
    const { applicationId, apiResponse, ownerId, buyertype } = payload;
    const requestPayload = {
      applicationId: applicationId.toString(),
      userId: apiResponse.userId,
    };
    if (buyertype === 'USER') {
      requestPayload.ownerUserId = ownerId;
      requestPayload.ownerCompanyId = null;
    }
    if (buyertype === 'COMPANY') {
      requestPayload.ownerUserId = null;
      requestPayload.ownerCompanyId = ownerId;
    }

    await OwnerService.addOffplanPOA(requestPayload);

    const resp = await OffPlanService.fetchOffPlanApplication(applicationId);
    dispatch({
      type: types.ADD_OFFPLAN_POA_SUCCESS,
      payload: { representativeDetails: resp.result?.representativeDetails },
    });
  } catch (error) {
    dispatch({ type: types.ADD_OFFPLAN_POA_ERROR, payload: error });
  }
};

export const deletePoA = (appId, repId, ownerId) => async (dispatch, getState) => {
  try {
    dispatch({ type: types.DELETE_OFFPLAN_POA });
    // Delete files from the DB
    const { applicationId, applicationType, documents } = getState().offPlanReducer;
    const removeFilesArray = documents
      .filter(doc => doc.poaOwnerId === ownerId && doc.type === 'POA_DOC')
      .map(item => {
        const params = {
          applicationId,
          applicationType,
          documentType: item.type,
          subType: item.subType,
          poaOwnerId: ownerId,
        };
        return deleteChain(params);
      });
    await Promise.all(removeFilesArray);

    await OffPlanService.deletePOA(appId + '/' + repId, null);
    dispatch({ type: types.DELETE_OFFPLAN_POA_SUCCESS, payload: {} });
    dispatch(fetchWorkFlowApplication(appId));
  } catch (error) {
    dispatch({ type: types.DELETE_OFFPLAN_POA_ERROR, payload: error });
  }
};

export const saveInstallmentPlan = (body, appId) => async dispatch => {
  try {
    dispatch({ type: types.SAVE_INSTALLMENT_PLAN });
    const installment = await OffPlanService.saveInstallmentPlan(body, appId);
    dispatch(fetchWorkFlowApplication(appId));
    return installment;
  } catch (error) {
    dispatch({ type: types.SAVE_INSTALLMENT_PLAN_ERROR, payload: error });
    return error;
  }
};

export const deleteInstallmentPlan = appId => async dispatch => {
  try {
    dispatch({ type: types.DELETE_INSTALLMENT_PLAN });
    await OffPlanService.deleteInstallmentPlan(appId);
    dispatch(fetchWorkFlowApplication(appId));
  } catch (error) {
    dispatch({ type: types.DELETE_INSTALLMENT_PLAN_ERROR, payload: error });
  }
};

export const getoffPlanPaymentBreakdown = (application, id) => async dispatch => {
  try {
    dispatch({ type: types.FETCH_OFFPLAN_PAYMENT_BREAKDOWN });
    const data = await OffPlanService.fetchOffPlanPaymentBreakDown(application, id);
    dispatch({
      type: types.FETCH_OFFPLAN_PAYMENT_BREAKDOWN_SUCCESS,
      payload: { breakdown: data?.result },
    });
    return data;
  } catch (error) {
    dispatch({
      type: types.FETCH_OFFPLAN_PAYMENT_BREAKDOWN_ERROR,
      payload: error,
    });
    return error;
  }
};
export const changeWorkflowStep = step => async dispatch => {
  dispatch({ type: types.CHANGE_OFF_PLAN_STEP, payload: { step } });
};
